import { Box, Chip, IconButton, SxProps } from '@mui/material';
import { CtaTypes, Variants } from '../CtaButton/CtaButton.interfaces';
import { Icon, Icons } from '../Icon/Icon';
import { ReactElement, useState } from 'react';
import {
  applyFilterButtonStyles,
  clearFilterButtonStyles,
  closeButtonStyles,
  filterButtonStyles,
  filterContainerStyles,
  filterCountStyles,
} from './Filter.styled';

import CtaButton from '../CtaButton/CtaButton';
import { FilterCheckboxListProps } from './components/FilterCheckboxList/FilterCheckboxList';
import { FilterVariant } from '@/widgets/FindAClass/classfinder.interfaces';

export default function Filter({
  translations,
  showLabel = true,
  onClearFilters,
  children,
  totalAmountOfFilteredItems,
  variant = FilterVariant.Classes,
  sx,
  filterCount,
}: {
  translations: Record<string, string>;
  showLabel?: boolean;
  children:
  | ReactElement<FilterCheckboxListProps>[]
  | ReactElement<FilterCheckboxListProps>;
  onClearFilters: () => void;
  totalAmountOfFilteredItems: number;
  variant: FilterVariant;
  sx?: SxProps;
  filterCount?: number;
}) {
  const [filterOpen, setFilterOpen] = useState(false);

  const addFilterButton = (
    <>
      {translations['filter.addfilterbutton']}
      {filterCount ? (
        <Chip
          sx={{ ...filterCountStyles, pointerEvents: 'none' }}
          label={filterCount}
          color="primary"
          size="small"
          onClick={(e) => e.stopPropagation()}
        />
      ) : null}
    </>
  );
  const clearFilterButton = translations['filter.clearfilter'];
  const applyFilterButton =
    variant === FilterVariant.Classes
      ? translations['filter.seeclasses']
      : translations['filter.seeclubs'];

  return (
    <Box sx={sx}>
      <CtaButton
        noArrow
        startIcon={Icons.Filter}
        buttonVariant={Variants.Outlined}
        onClick={() => setFilterOpen(!filterOpen)}
        ctaType={CtaTypes.Button}
        sx={filterButtonStyles}
        id="filter-button"
      >
        {showLabel ? addFilterButton : null}
      </CtaButton>

      <Box
        sx={filterContainerStyles(filterOpen, variant)}
        id="filter-container"
      >
        <CtaButton
          noArrow
          sx={clearFilterButtonStyles}
          buttonVariant={Variants.Textlink}
          onClick={onClearFilters}
          ctaType={CtaTypes.Button}
        >
          {clearFilterButton}
        </CtaButton>
        <IconButton sx={closeButtonStyles} onClick={() => setFilterOpen(false)}>
          <Icon icon={Icons.Times} />
        </IconButton>
        {children}
        <Box sx={applyFilterButtonStyles}>
          <CtaButton
            noArrow
            fullWidth
            buttonVariant={Variants.Black}
            ctaType={CtaTypes.Button}
            onClick={() => setFilterOpen(false)}
          >
            {applyFilterButton?.replace(
              '%amount%',
              totalAmountOfFilteredItems.toString()
            )}
          </CtaButton>
        </Box>
      </Box>
    </Box>
  );
}
